// extracted by mini-css-extract-plugin
export default {"content":"Wellcome_content_a4N6j","title":"Wellcome_title_Yv5wG","subtitle":"Wellcome_subtitle_TR1EN","text":"Wellcome_text_MM2J5"};